import { LegalPage } from '../components/LegalPage';

export default function PrivacyPolicyPage() {
  return (
    <LegalPage
      title="Privacy Policy"
      lastUpdated="30 marzo 2026"
      activePage="/privacy"
    >

      <div className="highlight-box">
        <p style={{ marginBottom: 0 }}>
          Il presente documento descrive come <strong>Francesco Russo</strong>, titolare della piattaforma Shangrilux, raccoglie, utilizza e protegge i dati personali degli utenti in conformità al <strong>Regolamento (UE) 2016/679 (GDPR)</strong> e al D.Lgs. 196/2003 come modificato dal D.Lgs. 101/2018.
        </p>
      </div>

      <h2>1. Titolare del Trattamento</h2>
      <p>
        Il Titolare del Trattamento dei dati personali è:
      </p>
      <ul>
        <li><strong>Nome:</strong> Francesco Russo</li>
        <li><strong>Email:</strong> <a href="mailto:info@shangrilux.com">info@shangrilux.com</a></li>
        <li><strong>Sito web:</strong> <a href="https://shangrilux.com">https://shangrilux.com</a></li>
        <li><strong>Piattaforma:</strong> Shangrilux — Smart Access & Booking Management Platform</li>
      </ul>
      <p>
        Per esercitare i propri diritti o per qualsiasi richiesta relativa al trattamento dei dati personali, è possibile contattare il Titolare all'indirizzo email sopra indicato.
      </p>

      <h2>2. Tipologie di Dati Raccolti</h2>

      <h3>2.1 Dati forniti direttamente dall'utente</h3>
      <p>Durante l'utilizzo della Piattaforma Shangrilux, possono essere raccolti i seguenti dati personali:</p>
      <ul>
        <li><strong>Dati identificativi:</strong> nome, cognome, denominazione aziendale</li>
        <li><strong>Dati di contatto:</strong> indirizzo email, numero di telefono</li>
        <li><strong>Dati professionali:</strong> ruolo aziendale, nome della struttura ricettiva</li>
        <li><strong>Dati di accesso:</strong> credenziali di autenticazione (password in forma crittografata)</li>
        <li><strong>Dati commerciali:</strong> piano di abbonamento scelto, informazioni di fatturazione</li>
        <li><strong>Dati degli ospiti finali:</strong> inseriti dai clienti B2B (tenant) nell'ambito del servizio (v. sezione 8)</li>
      </ul>

      <h3>2.2 Dati raccolti automaticamente</h3>
      <ul>
        <li><strong>Dati tecnici:</strong> indirizzo IP, tipo di browser, sistema operativo, dispositivo utilizzato</li>
        <li><strong>Dati di navigazione:</strong> pagine visitate, durata della sessione, URL di provenienza</li>
        <li><strong>Cookie e tecnologie analoghe:</strong> si rimanda all'apposita <a href="/cookie">Cookie Policy</a></li>
        <li><strong>Log di sistema:</strong> registrazioni degli accessi alla piattaforma per finalità di sicurezza</li>
      </ul>

      <h2>3. Finalità e Basi Giuridiche del Trattamento</h2>
      <table>
        <thead>
          <tr>
            <th>Finalità</th>
            <th>Base giuridica (GDPR)</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Erogazione del servizio Shangrilux e gestione dell'account</td>
            <td>Art. 6(1)(b) — Esecuzione di un contratto</td>
          </tr>
          <tr>
            <td>Risposta a richieste di demo, assistenza e contatto</td>
            <td>Art. 6(1)(b) — Esecuzione di un contratto / misure precontrattuali</td>
          </tr>
          <tr>
            <td>Fatturazione e gestione dei pagamenti</td>
            <td>Art. 6(1)(b) — Esecuzione di un contratto / Art. 6(1)(c) — Obbligo legale</td>
          </tr>
          <tr>
            <td>Invio di comunicazioni commerciali e newsletter (solo con consenso)</td>
            <td>Art. 6(1)(a) — Consenso dell'interessato</td>
          </tr>
          <tr>
            <td>Sicurezza della piattaforma, prevenzione frodi e log di accesso</td>
            <td>Art. 6(1)(f) — Legittimo interesse del Titolare</td>
          </tr>
          <tr>
            <td>Adempimento di obblighi fiscali e legali</td>
            <td>Art. 6(1)(c) — Obbligo legale</td>
          </tr>
          <tr>
            <td>Analisi aggregata delle performance della piattaforma (solo con consenso)</td>
            <td>Art. 6(1)(a) — Consenso dell'interessato</td>
          </tr>
        </tbody>
      </table>

      <h2>4. Periodi di Conservazione dei Dati</h2>
      <ul>
        <li><strong>Dati contrattuali e di fatturazione:</strong> conservati per 10 anni dalla fine del rapporto contrattuale, in adempimento degli obblighi fiscali (D.P.R. 633/1972)</li>
        <li><strong>Dati di accesso e log di sicurezza:</strong> conservati per 12 mesi dalla registrazione</li>
        <li><strong>Richieste di demo non convertite in contratto:</strong> conservati per 24 mesi</li>
        <li><strong>Dati trattati su base consenso:</strong> fino alla revoca del consenso da parte dell'interessato</li>
        <li><strong>Ambienti demo generati automaticamente:</strong> eliminati automaticamente dopo 24 ore dalla generazione</li>
      </ul>

      <h2>5. Destinatari e Comunicazione dei Dati</h2>
      <p>I dati personali possono essere comunicati alle seguenti categorie di soggetti:</p>

      <h3>5.1 Responsabili del Trattamento (ex art. 28 GDPR)</h3>
      <ul>
        <li><strong>Provider di hosting e infrastruttura cloud:</strong> per la conservazione sicura dei dati</li>
        <li><strong>Piattaforme di pagamento (es. Stripe):</strong> per l'elaborazione sicura dei pagamenti — operano con proprie policy di privacy</li>
        <li><strong>Fornitori di servizi email transazionali:</strong> per l'invio di notifiche operative</li>
        <li><strong>Servizi di analisi (solo con consenso):</strong> in forma aggregata e anonimizzata</li>
      </ul>

      <h3>5.2 Autorità pubbliche</h3>
      <p>I dati possono essere comunicati ad autorità pubbliche (es. Agenzia delle Entrate, Forze dell'Ordine) nei casi previsti dalla legge.</p>

      <h3>5.3 Non vendita a terzi</h3>
      <p>I dati personali degli utenti <strong>non vengono mai venduti</strong> a terzi né ceduti per finalità pubblicitarie proprie di soggetti terzi.</p>

      <h2>6. Trasferimento di Dati Extra-UE</h2>
      <p>
        Alcuni dei fornitori di servizi utilizzati da Shangrilux (es. provider di infrastruttura cloud) potrebbero trattare dati al di fuori dello Spazio Economico Europeo (SEE). In tali casi, il trasferimento avviene esclusivamente verso Paesi che garantiscono un livello di protezione adeguato o mediante l'adozione delle <strong>Clausole Contrattuali Standard</strong> approvate dalla Commissione Europea (art. 46 GDPR).
      </p>

      <h2>7. Diritti degli Interessati</h2>
      <p>In qualità di interessato, hai il diritto di:</p>
      <ul>
        <li><strong>Accesso (Art. 15 GDPR):</strong> ottenere conferma se siano in corso trattamenti di dati che ti riguardano e richiederne copia</li>
        <li><strong>Rettifica (Art. 16 GDPR):</strong> richiedere la correzione di dati inesatti o incompleti</li>
        <li><strong>Cancellazione ("diritto all'oblio", Art. 17 GDPR):</strong> richiedere la cancellazione dei tuoi dati quando non sono più necessari o in caso di revoca del consenso</li>
        <li><strong>Limitazione del trattamento (Art. 18 GDPR):</strong> richiedere la limitazione del trattamento in determinati casi</li>
        <li><strong>Portabilità (Art. 20 GDPR):</strong> ricevere i tuoi dati in formato strutturato e leggibile da dispositivo automatico</li>
        <li><strong>Opposizione (Art. 21 GDPR):</strong> opporti in qualsiasi momento al trattamento dei tuoi dati per finalità di marketing diretto</li>
        <li><strong>Revoca del consenso:</strong> revocare in qualsiasi momento il consenso prestato, senza che ciò pregiudichi la liceità del trattamento precedente</li>
      </ul>
      <p>Per esercitare i tuoi diritti, invia una richiesta a: <a href="mailto:info@shangrilux.com">info@shangrilux.com</a>. Il Titolare risponderà entro <strong>30 giorni</strong> dalla ricezione della richiesta.</p>

      <h2>8. Dati degli Ospiti Finali (Clienti B2B)</h2>
      <div className="highlight-box">
        <p style={{ marginBottom: 0 }}>
          I clienti B2B (tenant) che utilizzano la piattaforma Shangrilux per gestire prenotazioni e accessi dei propri ospiti agiscono come <strong>Titolari autonomi del trattamento</strong> per i dati degli ospiti stessi. Shangrilux, in tale contesto, opera come <strong>Responsabile del Trattamento</strong> ai sensi dell'art. 28 GDPR. Le modalità di tale rapporto sono disciplinate nell'apposito <em>Accordo sul Trattamento dei Dati (DPA)</em> allegato ai Termini e Condizioni di servizio.
        </p>
      </div>

      <h2>9. Sicurezza dei Dati</h2>
      <p>Il Titolare adotta misure tecniche e organizzative adeguate per proteggere i dati personali da accessi non autorizzati, perdita accidentale, distruzione o alterazione, tra cui:</p>
      <ul>
        <li>Trasmissione dei dati cifrata tramite protocollo TLS/HTTPS</li>
        <li>Archiviazione delle password in forma crittografata (hashing con salt)</li>
        <li>Accesso ai dati limitato al solo personale autorizzato</li>
        <li>Monitoraggio continuo dei log di accesso</li>
        <li>Ambienti demo isolati e con cancellazione automatica entro 24 ore</li>
      </ul>

      <h2>10. Cookie</h2>
      <p>Per informazioni dettagliate sull'utilizzo dei cookie da parte di Shangrilux, si rimanda alla <a href="/cookie">Cookie Policy</a>.</p>

      <h2>11. Reclami all'Autorità di Controllo</h2>
      <p>
        Hai il diritto di proporre reclamo al <strong>Garante per la protezione dei dati personali</strong> (Autorità di controllo italiana) qualora ritieni che il trattamento dei tuoi dati violi il GDPR.
      </p>
      <ul>
        <li><strong>Sito web:</strong> <a href="https://www.garanteprivacy.it" target="_blank" rel="noopener noreferrer">www.garanteprivacy.it</a></li>
        <li><strong>Email:</strong> <a href="mailto:garante@gpdp.it">garante@gpdp.it</a></li>
        <li><strong>PEC:</strong> protocollo@pec.gpdp.it</li>
      </ul>

      <h2>12. Modifiche alla Privacy Policy</h2>
      <p>
        Il Titolare si riserva il diritto di modificare la presente Privacy Policy in qualsiasi momento, anche al fine di adeguarla a eventuali cambiamenti normativi. Le modifiche sostanziali verranno comunicate agli utenti registrati tramite email o mediante avviso in evidenza sulla piattaforma con almeno 15 giorni di preavviso. La versione aggiornata sarà sempre disponibile alla URL <a href="/privacy">https://shangrilux.com/privacy</a>.
      </p>

    </LegalPage>
  );
}
